import React from 'react';
import { Button } from 'react-bootstrap';

const FloatingButton = ({ text, variant = 'dark', disabled = false, Icon, onClick }) => {
  return (
    <Button
      variant={variant}
      style={{
        position: 'fixed',
        right: 0,
        bottom: '1.5rem',
        marginBottom: 'env(safe-area-inset-bottom, 0px)',
        zIndex: 2
      }}
      className="mr-4 viewport-chrome-offset"
      disabled={disabled}
      size="sm"
      onClick={onClick}
    >
      {Icon && <Icon className="mr-2" />}
      <span className="align-middle">{text}</span>
    </Button>
  );
};

export default FloatingButton;
